<template>
  <i-select :value="value" :clearable="true" v-on="$listeners">
    <i-option v-for="(label, key) in sources" :key="key" :value="key" :label="label" />
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    computed: {
      sources: function () {
        return this.$t('mailer.stats.general.filter.source.values');
      }
    }
  };
</script>
